export const getEntitiesWithVisibility = (entities, itemId, isToggled) => {
  let newEntities;
  if (itemId === 'root') {
    newEntities = entities.map((r) => ({ ...r, visible: !isToggled }));
  } else {
    newEntities = [...entities];
    newEntities[itemId].visible = !isToggled;
  }
  return newEntities;
};

export const getCenteredEntities = (entities, itemId) => {
  if (!entities || entities.length === 0) return undefined;

  if (itemId === 'root') {
    return entities.map((entity) => {
      if (!entity.geometry) return { coordinates: [entity.coordinate] };
      return entity.geometry;
    });
  }

  if (entities[itemId]) {
    if (!entities[itemId].geometry) return [{ coordinates: [entities[itemId].coordinate] }];
    return [entities[itemId].geometry];
  }

  return undefined;
};
